import { getGraphqlErrorExtensions } from '@/apollo/utils/getGraphqlErrorExtensions';

// Sub-codes are the server's domain codes, such as INTERVENTION_VERSION_CONFLICT:
// more precise than the code when a screen reacts to one specific case.
export const hasGraphqlErrorSubCode = (error: unknown, subCode: string) =>
  getGraphqlErrorExtensions(error).some(
    (graphqlErrorExtensions) => graphqlErrorExtensions.subCode === subCode,
  );
